import { CircleAlert } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'
import { CALLOUT_WARNING } from '../recipes'

export interface WarningCalloutProps {
  children: ReactNode
  className?: string
}

/**
 * What stands in the way, said in words on the warning surface: an icon and the text, announced
 * as an alert. For a notice with a title and a retry use the screen's own notice instead.
 */
export function WarningCallout({ children, className }: WarningCalloutProps) {
  return (
    <p role="alert" className={cn(CALLOUT_WARNING, className)}>
      <CircleAlert aria-hidden className="mt-px size-4 shrink-0" />
      {children}
    </p>
  )
}
